// Types of agents-admin-api v1.0 — shared by the admin-agents function and the console client.
// Kept inside functions/ so the function bundle never reaches outside its own tree.
export const AGENT_STATES = ["active", "paused", "disabled"] as const;
export const RUN_STATES = ["queued", "running", "succeeded", "failed", "killed"] as const;
export const ACK_STATES = ["acknowledged-stop", "unknown-unreachable", "running"] as const;

export type AgentState = (typeof AGENT_STATES)[number];
export type RunState = (typeof RUN_STATES)[number];
export type AckState = (typeof ACK_STATES)[number];

export interface AgentsOverview {
  generated_at: string;
  kill: { epoch: number; active: boolean; reason: string | null; set_at: string | null; set_by: string | null };
  leases: { holder: string; ack_state: AckState; epoch_seen: number | null; last_ack_at: string | null; lease_expires_at: string | null }[];
  budget: { month: string; cap_eur: number; estimated_eur: number; invoiced_eur: number; infra_allowance_eur: number; fixed_eur: number };
  orgs: { org_id: string; name: string }[];
  agents: { agent_id: string; name: string; org_id: string; org_name: string; version: string; state: AgentState; last_run_at: string | null }[];
  runs_24h: {
    by_state: Record<RunState, number>;
    items: { run_id: string; agent_id: string; agent_name: string; state: RunState; started_at: string; finished_at: string | null; cost_eur: number }[];
  };
}
